"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  LEAD_FLOWS_APP: 'lead-flows',
  MARKETING_STARTER_PRODUCT: 'marketing-starter'
};
exports.default = _default;
module.exports = exports.default;